import BaseModel from "./BaseModel";
import {getDocs, limit, orderBy, query, where, startAt, startAfter} from "firebase/firestore";

export default class GraphQLTask extends BaseModel {
    static data_name = "graph_ql_tasks";



}